import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7rkbvdp47b: FaireBrandEntity = {
  token: "b_7rkbvdp47b",
  type: "brand",
  name: "Karma Nepal Crafts",
  avatarUrl:
    "https://cdn.faire.com/fastly/b873e4ab119f322866949cb2f85a5d53a962e2c48ccde99642a448635e0c142c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ddfe4fc4fc7fabb8814663e3f0869a048cb6ecbea8e6a42fb6250db640aa2690.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b873e4ab119f322866949cb2f85a5d53a962e2c48ccde99642a448635e0c142c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ddfe4fc4fc7fabb8814663e3f0869a048cb6ecbea8e6a42fb6250db640aa2690.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 148,
  isInsider: true,
  description:
    "We are a women-owned  business that sells handmade clothing accessories that are mostly hand-made by local women artists of Nepal, India, and Thailand. These handmade items are hand-picked by our team at Karma Nepal Crafts to ensure quality and craftsmanship, colors and designs that adorn and inspire you.\n\nEach product has been personally handpicked and made by the local women artists from Nepal, India and Thailand. All these women artists have fled their homes because of domestic violence and all they know is the beautiful crafts that they make. So, by purchasing the products, we are helping them to grow and live life independently.\n ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:00.080Z",
    importedBy: "entity-db-cli",
  },
};
